<template>
  <div class="user-collection por">
    <df-tabs :tabs="tabs" v-model="formatId" :format="i => +i + 1"></df-tabs>
    <div class="line poa w100 l0"></div>
    <template v-if="listLength">
      <div class="list flex fww">
        <course-card :item="course" class="course"
                     :img-key="+formatId === 2 ? 'course_bgimg' : 'course_bigimg'"
                     image-width="202"
                     hidden-audio
                     @detail="courseClick"
                     width="202"
                     image-height="114"
                     show-props="course_name"
                     v-for="(course, j) in list" :key="j">
          <template #image="{item}">
            <div class="course-image-box">
              <i class="mine-ico poa audio img" v-show="item.format_id === 2"></i>
              <div class="hover-box poa dn w100 h100 t0 l0 zi1" :class="{'hover-show': !isEdit}" @click.stop>
                <i class="hover-to-play abs-mc mine-ico hover-play csp" @click="courseClick(item)"></i>
                <i class="hover-del-one poa mine-ico hover-delete img csp"
                   @click="delCourse(item.id, 0, j)"></i>
              </div>
              <div class="edit-checkbox zi1 poa t0 l0 r0" v-show="isEdit">
                <i class="mine-ico abs-m"
                   :class="selected.includes(item.id) ? 'checkbox-check' : 'checkbox-df'"></i>
              </div>
            </div>
          </template>
        </course-card>
      </div>
      <mine-edit v-model="isEdit"
                 :selected="selected.length"
                 @edit-callback="editCb"
                 class="edit"></mine-edit>
      <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
    </template>
    <template v-else-if="total === null">
      <!-- no list -->
      <mine-no-data></mine-no-data>
    </template>
    <template v-else>
      <df-loading></df-loading>
    </template>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Mixins from '../../mixins/mixins';
  import MineEdit from '../../components/mine/edit';


  export default {
    name: "UserPlay",
    components: {
      MineEdit,
    },
    mixins: [Mixins.AppScroll(), Mixins.MakeRoute({'format_id': 'formatId'}, 'query', 'replace')],
    // appScroll(e) {
    //   let {height} = e.target.getBoundingClientRect();
    //   let {bottom} = this.$el.getBoundingClientRect();
    //   if (bottom - height / 3 < height && !this.isAllLoad && !this.isLoading) {
    //     this.curr++;
    //     this.getList();
    //   }
    // },
    watch: {
      formatId() {
        this.total = 0;
        this.isEdit = false;
        this.isLoading = false;
        this.selected = [];
        this.list = [];
        this.getList(1);
      },
      $route(val){
        !this.userInfo.uid && this.ToLogin();
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      isAllLoad() {
        return this.listLength >= this.total && this.total;
      },
      listLength() {
        return this.list.length;
      },
    },
    data() {
      return {
        isEdit: false,

        isLoading: false,

        selected: [],
        list: [],
        tabs: ['视频', '音频'],

        curr: 1,
        limits: 20,
        total: 0,
      };
    },
    created() {
      this.formatId ? this.getList(1) : (this.formatId = 1);
    },
    methods: {
      changePage(val, prop){
        if(this.curr === val) return;
        this.curr = val;
        this.getList();
      },
      editCb(type) {
        switch (type) {
          case 'all':
            this.selected = this.list.map(e => e.id);
            break;
          case 'del':
            this.delCourse();
            break;
          case 'cancel':
            this.selected = [];
            this.isEdit = false;
            break;
        }
      },
      courseClick(item) {
        if (this.isEdit) {
          if (this.selected.includes(item.id)) {
            this.selected = this.selected.filter(id => id !== item.id);
          } else {
            this.selected.push(item.id);
          }
        } else {
          this.OpenRouter({
            path: (item.format_id === 2 ? '/home/audio/details/' : '/home/video/details/') + item.course_id + '/' + item.is_free,
            query: {
              rid: item.before_resource_id,
            }
          });
        }
      },
      delCourse(id, i, j) {
        if (id || this.selected.length) {
          let params = {
            ids: (id ? [id] : this.selected) + '',
          };
          this.http.del(params).then(res => {
            this.ShowToast('删除成功！');
            this.selected = [];
            if (id) {
              this.list.splice(j, 1);
              this.getList('isDel', this.listLength + 1);
            } else {
              this.getList(1);
            }
          }).catch(this.$err);
        }
      },
      getList(init, curr) {
        if(!this.userInfo.uid) return;
        if (this.isLoading) return;
        this.isLoading = true;
        if (init !== 'isDel' && init) {
          this.curr = 1;
        }
        this.http.list({
          uid: this.userInfo.uid,
          curr: this.curr,
          limits: this.limits,
          format_id: this.formatId,
          ...this.Product,
        }, { needCancel: 'url' }).then(res => {
          if (this.curr === 1 && !curr) {
            this.list = [];
          }
          this.total = res.total || null;
          this.list = res.list;
        }).catch(this.$err).finally(() => {
          this.isLoading = false;
					//当删除完当页数据，导致查询数据为空是，查询上一页数据
					if(this.total &&this.curr>1 && !this.list.length){
						this.curr--;
						this.getList();
						return
					}
        });
      },
    },
  }
</script>

<style scoped lang="less">

  .course-image-box {
    .audio {
      left: 8px;
      bottom: 5px;
    }
    .hover-box {
      cursor: unset;
      background-color: rgba(0, 15, 34, .5);
    }
    .hover-delete {
      top: 6px;
      right: 8px;
    }
    .edit-checkbox {
      height: 32px;
      line-height: 0;
      background: linear-gradient(180deg, rgba(0, 15, 34, 0.5), rgba(0, 15, 34, 0));
      .mine-ico {
        right: 8px;
      }
    }
  }

  .edit {
    top: 25px !important;
  }

  .user-collection {
    padding: 16px 18px;
  }

  .list {
    margin-left: -16px;
  }

  .line {
    transform: translateY(-24px);
    height: 1px;
    background-color: #eee;
  }

  .course-card {
    margin: 0 0 24px 16px;
    align-items: unset;
    &:hover {
      /deep/ .course_name {
        color: #333f4e;
      }
      /deep/ .resources_name {
        color: #999fa6;
      }
    }
    /deep/ .course_name {
      font-size: 16px;
      color: #333f4e;
      &:hover {
        color: #1177ff;
      }
    }
    /deep/ .resources_name {
      padding-top: 10px;
      font-size: 14px;
      color: #999fa6;
    }
    /deep/ .detail-box {
      padding: 0;
    }
    /deep/ .vip-type-tip {
      display: none;
    }
  }
  /deep/ .df-loading{
    padding-top: 100px;
    .loading-tip{
      color: #333;
    }
  }
</style>